import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { navigateToPath } from '../../actions/navigation';
import { NAV_DIRECTIONS } from '../../actions/constants';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';
import Checklist from '../../components/Checklist';
import HeadingForm from '../../layout/HeadingForm';
import Toggle from '../../components/Toggle';
import { NAV_DELAY } from '../../helpers/navigation';
import { getSign, getNumber } from '../../helpers/sections';
import { logger } from '../../helpers/logger';

let ts;

const Select = ({
  localePath,
  yesNoQuestion,
  isNumberQuestion,
  options,
  onChange,
  goForward,
  values,
  name,
  checklist,
  checklistIconClass,
}, { t }) => {
  const onClick = value => () => {
    const target = { name, type: 'text', value };
    logger.log('[degree-of-care] Wybrana wartość:', value, 'name:', name);
    onChange({ target });
    clearTimeout(ts);
    ts = setTimeout(goForward, NAV_DELAY);
  };

  const columns = Object.keys(checklist).map(top => Object.keys(checklist[top]).map(val => ({
    label: t(`${localePath}.checklist.${top}.${val}`),
    icon: checklist[top][val],
  })));


  const currentValue = values[name];
  const optionsLength = options.length;

  return (
    <ContentWrapper>
      <HeadingForm
        value={t(`${localePath}.heading`)}
        commentValue={t(`${localePath}.comment`)}
        tooltipTitle={t(`${localePath}.tooltip.title`)}
        tooltipContent={t(`${localePath}.tooltip.content`)}
      />
      <Checklist columns={columns} iconClass={checklistIconClass} />
      {options.map(({ key, sign }, index) => (
        <Toggle
          key={key}
          index={index}
          option={key}
          onClick={onClick(key)}
          selected={currentValue === key}
          sign={sign || (isNumberQuestion ? getNumber(index, optionsLength) : getSign(index, yesNoQuestion, t))}
          toggleText={t(`${localePath}.options.${key}`)}
          complementaryText={t(`${localePath}.options.${key}-comment`)}
        />
      ))}
    </ContentWrapper>
  );
};

Select.propTypes = {
  localePath: PropTypes.string,
  name: PropTypes.string,
  yesNoQuestion: PropTypes.bool,
  isNumberQuestion: PropTypes.bool,
  values: PropTypes.objectOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func,
  goForward: PropTypes.func,
  checklist: PropTypes.objectOf(PropTypes.shape()),
  checklistIconClass: PropTypes.string,
};

Select.defaultProps = {
  localePath: '',
  name: '',
  values: {},
  options: [],
  yesNoQuestion: false,
  isNumberQuestion: false,
  onChange: () => {},
  goForward: () => { },
  checklist: {},
  checklistIconClass: '',
};

Select.contextTypes = {
  t: PropTypes.func,
};

export { Select as SelectPlain };

/* istanbul ignore next */
const mapStateToProps = ({ formData }) => {
  logger.log('[formData] Aktualny stan:', formData); // <-- DODAJ TO
  return { formData };
};
/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  goForward: () => dispatch(navigateToPath(NAV_DIRECTIONS.NEXT)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Select);
